module.exports = __webpack_public_path__ + "img/qualitas_new.cc118464.svg";